export const LETTERS_REGEX = new RegExp('^[a-zA-Z]+( [a-zA-Z]+)*$');
export const EMAIL_REGEXP = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
export const LETTERS_AND_NUMBERS_REGEX = new RegExp('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$');
export const PHONE_NUMBER_REGEX = new RegExp('^[0-9 ]{11}$');
export const DIGITS_REGEX = new RegExp('^[0-9]+$');
export const CODE_REGEX = new RegExp('^[0-9]{6}$');

export function allowOnlyLetters(event: KeyboardEvent) {
  const key = event.key;
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (LETTERS_REGEX.test(key)) return;

  if (key === ' ' && value.length > 0 && LETTERS_REGEX.test(value) && !value.endsWith(' ')) {
    return;
  }

  event.preventDefault();
}

export function allowPasteOnlyLetters(event: ClipboardEvent) {
  const pasted = event.clipboardData?.getData('text') ?? '';
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const newValue = value.substring(0, selectionStart) + pasted + value.substring(selectionEnd);

  if (!LETTERS_REGEX.test(newValue)) {
    event.preventDefault();
  }
}

export function allowDropOnlyLetters(event: DragEvent) {
  const dropped = event.dataTransfer?.getData('text') ?? '';
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const newValue = value.substring(0, selectionStart) + dropped + value.substring(selectionEnd);

  if (!LETTERS_REGEX.test(newValue)) {
    event.preventDefault();
  }
}

export function allowOnlyLettersAndNumbers(event: KeyboardEvent) {
  const key = event.key;
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (LETTERS_AND_NUMBERS_REGEX.test(key)) return;

  if (key === ' ' && value.length > 0 && LETTERS_AND_NUMBERS_REGEX.test(value) && !value.endsWith(' ')) {
    return;
  }

  event.preventDefault();
}

export function allowPasteOnlyLettersAndNumbers(event: ClipboardEvent) {
  const pasted = event.clipboardData?.getData('text') ?? '';
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const newValue = value.substring(0, selectionStart) + pasted + value.substring(selectionEnd);

  if (!LETTERS_AND_NUMBERS_REGEX.test(newValue)) {
    event.preventDefault();
  }
}

export function allowDropOnlyLettersAndNumbers(event: DragEvent) {
  const dropped = event.dataTransfer?.getData('text') ?? '';
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const newValue = value.substring(0, selectionStart) + dropped + value.substring(selectionEnd);

  if (!LETTERS_AND_NUMBERS_REGEX.test(newValue)) {
    event.preventDefault();
  }
}

export function validateEmail(email: string): boolean {
  return EMAIL_REGEXP.test(email);
}

export function validatePhoneNumber(phoneNumber: string): boolean {
  return PHONE_NUMBER_REGEX.test(phoneNumber);
}

export function validateDigitsOnly(input: string): boolean {
  return DIGITS_REGEX.test(input);
}

export function allowOnlyDigits(event: KeyboardEvent) {
  const key = event.key;
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (DIGITS_REGEX.test(key)) return;

  if (key === ' ' && value.length > 0 && DIGITS_REGEX.test(value) && !value.endsWith(' ')) {
    return;
  }

  event.preventDefault();
}

export function allowPasteOnlyDigits(event: ClipboardEvent) {
  const pasted = event.clipboardData?.getData('text') ?? '';
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const newValue = value.substring(0, selectionStart) + pasted + value.substring(selectionEnd);

  if (!DIGITS_REGEX.test(newValue)) {
    event.preventDefault();
  }
}

export function allowDropOnlyDigits(event: DragEvent) {
  const dropped = event.dataTransfer?.getData('text') ?? '';
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const newValue = value.substring(0, selectionStart) + dropped + value.substring(selectionEnd);

  if (!DIGITS_REGEX.test(newValue)) {
    event.preventDefault();
  }
}
